import { Swiper, Navigation, Pagination } from 'swiper';

export default ProductRecommendations = () => {
    const initSwiper = () => {
        Swiper.use(Navigation, Pagination);
        const recommendedProductCarousel = document.querySelectorAll('.product-section-recommendations .swiper').forEach(carousel => {
            const container = carousel.closest( 'section');
            const nextEl = container.querySelector('.swiper-button-next');
            const prevEl = container.querySelector('.swiper-button-prev');
            const swiper = new Swiper(carousel, {
                direction: 'horizontal',
                slidesPerView: 1.2,
                spaceBetween: 16,
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 1.8,
                    },
                    768: {
                        slidesPerView: 2.2,
                    },
                    992: {
                        slidesPerView: 4,
                    },
                }
            });
        })
    }

    const init = () => {
        const productRecommendationsSection = document.querySelectorAll('.product-section-recommendations .product-section-recommendations__inner');
        productRecommendationsSection.forEach(section => {
            let productId = section.dataset.productId;
            let limit = section.dataset.limit;
            let min = section.dataset.minrecommendations;
            fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productId+"&limit="+limit+"&section_id=product-recommendations&intent=related")
            .then(response => response.text())
            .then((text) => {
                const html = document.createElement('div');
                html.innerHTML = text;

                if (html.querySelectorAll('.swiper-slide').length > min) {
                    const recommendations = html.querySelector('.swiper');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        const recommendedPlaceholders = section.querySelector('.swiper');
                        recommendedPlaceholders.innerHTML = recommendations.innerHTML;
                        initSwiper();
                    }
                } else {
                    initSwiper();
                }
            });
        });
    }

    // For shopify customizer/editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
            init();
        }
    });

    init();
}